module.exports = __webpack_public_path__ + "img/unesco.e3473dfd.png";